import { SCORE_MEDIAN } from "@/constants";
import { LOCAL } from "@/store/mutations";

const { SET_BALANCE } = LOCAL;

export default {
	namespaced: true,
	state: {
		amount: 0,
	},
	actions: {
		configureApp: {
			root: true,
			handler({ commit }, configData) {
				commit(SET_BALANCE, { amount: configData.config.initial_balance });
			},
		},
		calculate({ commit, rootGetters }) {
			const averagedScore = rootGetters["game/scores/averaged"];
			const sharpAmount = (averagedScore + SCORE_MEDIAN) * rootGetters["game/chapters/active"].target_payout;
			const roundedAmount = Math.round(sharpAmount / rootGetters["global/api/constants"].rounding_step_size)
				* rootGetters["global/api/constants"].rounding_step_size;

			commit(SET_BALANCE, { amount: roundedAmount });
		},
	},
	mutations: {
		[SET_BALANCE](state, balance) {
			state.amount = balance.amount;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/game/balance.store.js